import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CheckIcon } from 'lucide-react';
import { useApplyModal } from './ApplyModalContext';
export function CreatorLab() {
  const {
    open
  } = useApplyModal();
  return <section className="py-24 px-6 relative bg-navy-950 border-t border-white/5" data-id="element-46">
      <div className="max-w-4xl mx-auto" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-navy-900 to-navy-950 border border-white/10 rounded-3xl p-8 md:p-12 relative overflow-hidden box-glow" data-id="element-48">
          {/* Decorative Glow */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-mint/10 rounded-full blur-[80px] pointer-events-none" data-id="element-49" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-electric/10 rounded-full blur-[80px] pointer-events-none" data-id="element-50" />
          <div className="relative z-10" data-id="element-51">
            <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-white mb-4" data-id="element-52">
              Bring your next big move to the Creator Lab.
            </h2>
            <p className="text-xl text-slate-300 mb-6 font-medium" data-id="element-53">
              We are inviting a small group of creators to test Pulsewave around
              real decisions about what to create, launch, or build next.
            </p>
            <p className="text-slate-400 mb-10 max-w-2xl leading-relaxed" data-id="element-54"></p>
            <div className="grid sm:grid-cols-2 gap-4 mb-10" data-id="element-55">
              {['Paid pilot', 'Limited creator cohort', 'Real creator decisions', 'Built for creators ready to do more with their audience'].map((point, i) => <div key={i} className="flex items-start gap-3" data-id="element-56">
                  <div className="mt-1 w-5 h-5 rounded-full bg-mint/20 flex items-center justify-center shrink-0" data-id="element-57">
                    <CheckIcon className="w-3 h-3 text-mint" data-id="element-58" />
                  </div>
                  <span className="text-sm text-slate-300" data-id="element-59">{point}</span>
                </div>)}
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-6" data-id="element-60">
              <Button variant="primary" onClick={open} className="w-full sm:w-auto text-base py-3 px-8" data-id="element-61">
                Apply to the Creator Lab
              </Button>
            </div>
            <p className="mt-8 text-sm text-slate-500 max-w-2xl" data-id="element-62">
              If you know there is a bigger move hiding in your audience,
              Pulsewave helps you find it and bring your fans along before it
              ships.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}